
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/philippines",
      function () {
        return require("private-next-pages/philippines.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/philippines"])
      });
    }
  